/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_RerunInputs */

const cs_ebr_history_rerun = /** @type {(inputs: Ebr_History_RerunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit znovu`)
};

const en_ebr_history_rerun = /** @type {(inputs: Ebr_History_RerunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run again`)
};

/**
* | output |
* | --- |
* | "Run again" |
*
* @param {Ebr_History_RerunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_rerun = /** @type {((inputs?: Ebr_History_RerunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_RerunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_rerun(inputs)
	return cs_ebr_history_rerun(inputs)
});